module.exports = __webpack_public_path__ + "img/9E9C77_6E6F4E_7C7C54_C7BF96-256px.daf8c23e.png";